<template>
  <div v-if="dataChildren.length > 0" class="layout-detail-form">
    <div v-if="conf && conf.bpmConfig && conf.bpmConfig.direction === 'row'" class="detail-row">
      <div class="detail-header">
        <div class="detail-index">#</div>
        <div v-for="(item, index) in dataChildren" :key="index" class="row-item" :class="{hideColumns: formEditList[item.vModel] && formEditList[item.vModel].operationType === 4}">
          <span v-if="item.bpmConfig && item.bpmConfig.required" class="required">*</span>{{ item.bpmConfig && item.bpmConfig.label || '' }}
        </div>
        <div v-if="!disabled" class="form-actions">操作</div>
      </div>
      <div v-for="(item, index) in list" :key="index" class="detail-body">
        <div class="detail-index">{{ index + 1 }}</div>
        <div v-for="(item2, index2) in dataChildren" :key="index2" class="row-item" :class="{hideColumns: formEditList[item2.vModel] && formEditList[item2.vModel].operationType === 4}">
          <keep-alive>
            <render
              v-if="conf.vModel"
              :form-data="formData"
              :text-show="true"
              :field="conf.vModel"
              :field-data="list[index]"
              :text-lable="list[index]['confList'][index2] && list[index]['confList'][index2].bpmConfig && list[index]['confList'][index2].bpmConfig.label || ''"
              :system-info="systemInfo"
              :is-edit-hisotry="isEditHisotry"
              :is-text="disabled || (formEditList[item2.vModel] && formEditList[item2.vModel].operationType === 3)"
              :conf="list[index]['confList'][index2]"
              :is-parse="true"
              @input="(val) => setValue(val, list[index]['confList'][index2], index)"
            />
          </keep-alive>
        </div>
        <div v-if="!disabled" class="form-actions">
          <span class="copy" @click="copyItem(index)">复制</span>
          <span class="del" @click="deleteItem(index)">删除</span>
        </div>
      </div>
    </div>
    <div v-else class="detail-column">
      <div v-for="(item, index) in list" :key="index" class="detail-column-body">
        <div v-for="(item2, index2) in dataChildren" :key="index2" :class="{hideColumns: formEditList[item2.vModel] && formEditList[item2.vModel].operationType === 4}">
          <div class="detail-index"><span v-if="item2.bpmConfig && item2.bpmConfig.required" class="required">*</span>{{ item2.bpmConfig && item2.bpmConfig.label || '' }}</div>
          <div>
            <keep-alive>
              <render
                v-if="conf.vModel"
                :form-data="formData"
                :text-show="true"
                :field="conf.vModel"
                :field-data="list[index]"
                :text-lable="list[index]['confList'][index2] && list[index]['confList'][index2].bpmConfig && list[index]['confList'][index2].bpmConfig.label || ''"
                :system-info="systemInfo"
                :is-edit-hisotry="isEditHisotry"
                :is-text="disabled || (formEditList[item2.vModel] && formEditList[item2.vModel].operationType === 3)"
                :conf="list[index]['confList'][index2]"
                :is-parse="true"
                @input="(val) => setValue(val, list[index]['confList'][index2], index)"
              />
            </keep-alive>
          </div>
        </div>
        <action-icon v-if="!disabled" :index="index" @delete="deleteItem" @copy="copyItem" />
      </div>
    </div>
    <div v-if="!disabled" class="drag-add">
      <svg-icon icon-class="form-add" @click.native="addDetails" />
      <span @click="addDetails">{{ conf.bpmConfig && conf.bpmConfig.actionName || '' }}</span>
    </div>
  </div>
</template>

<script>
import ActionIcon from './icon.vue'
import render from '@/views/form/components/render/render.js'
import cloneDeep from 'lodash/cloneDeep'
export default {
  components: {
    render,
    ActionIcon
  },
  props: {
    // 是否存在編輯記錄中
    isEditHisotry: {
      type: Boolean, // 禁止编辑
      default: false
    },
    disabled: {
      type: Boolean, // 禁止编辑
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'row'
    },
    children: {
      type: Array,
      default: () => []
    },
    // 配置
    conf: {
      type: Object,
      default: () => {}
    },
    // 系统变量
    systemInfo: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    formEditList() {
      return this.conf && this.conf.formEditList || {}
    },
    dataChildren() {
      // const formEditList = this.conf.formEditList
      return this.children.filter((item) => item.type !== 'empty')
    }
  },
  created() {},
  mounted() {
    if (this.value.length > 0) {
      this.list = cloneDeep(this.value)
      const list = this.list.map((item, index) => {
        item.confList = []
        this.dataChildren.forEach((item2, index2) => {
          if (item2.vModel) {
            item.confList[index2] = cloneDeep(item2)
            item.confList[index2].bpmConfig.defaultValue = item[item2.vModel]
          }
        })
        return item
      })
      this.list = list
      console.log('conf', this.conf)
    }
  },
  methods: {
    setValue(value, item, index) {
      this.list[index][item.vModel] = value
      this.$set(item.bpmConfig, 'defaultValue', value)
      this.$emit('input', cloneDeep(this.list))
    },
    // 添加明细
    addDetails() {
      const obj = {
        confList: []
      }
      this.dataChildren.forEach((item, index) => {
        if (item.vModel) {
          obj[item.vModel] = item.bpmConfig && item.bpmConfig.defaultValue
          obj.confList[index] = cloneDeep(item)
        }
      })
      this.list.push(obj)
      this.$emit('input', cloneDeep(this.list))
    },
    copyItem(index) {
      this.list.push(cloneDeep(this.list[index]))
      this.$emit('input', cloneDeep(this.list))
    },
    deleteItem(index) {
      this.list.splice(index, 1)
      this.$emit('input', cloneDeep(this.list))
    }
  }
}
</script>

<style lang="scss" scoped>
  .layout-detail-form {
    margin-bottom: 10px;
    .required {
      content: '*';
      color: #ff4949;
      margin-right: 4px;
    }
    .hideColumns {
      display: none;
    }
    .detail-row {
      border-top: 1px solid #E5E6EB;
      border-left: 1px solid #E5E6EB;
      overflow: hidden;
      overflow-x: auto;
      border-radius: 4px;
      .detail-header, .detail-body {
        color: #86909C;
        display: flex;
        >div {
          font-size: 12px;
          background: #F4F7FF;
          min-height: 28px;
          padding: 10px 16px;
          box-shadow: inset 0px -1px 0px 0px #E5E6EB, inset -1px 0px 0px 0px #E5E6EB;
        }
        >div:nth-of-type(1) {
          width: 56px;
        }
        >div:nth-of-type(n + 1) {
          flex: 1;
        }
        .form-actions {
          max-width: 100px;
          min-width: 100px;
          .copy {
            color: #2C51EF;
            cursor: pointer;
            margin-right: 10px;
          }
          .del {
            color: #ff4949;
            cursor: pointer;
          }
        }
      }
        .detail-body {
          color: #1D2129;
          >div {
            background: #fff;
        }
      }
      .detail-index {
        width: 60px;
        max-width: 60px;
        min-width: 60px;
      }
      .row-item {
        min-width: 200px;
        overflow-x: auto;
      }
    }
    .detail-column {
      border-radius: 4px;
      border-top: 0px;
      >div {
        background: #FFFFFF;
        color: #1D2129;
      }
      .detail-column-body {
        border: 1px solid #E5E6EB;
        border-radius: 4px;
        margin-bottom: 16px;
        position: relative;
      }
      .detail-index {
        padding-left: 21px;
        background: #F7F8FA;
        color: #86909C;
        line-height: 36px;
        &+div {
          background: #FFFFFF;
          color: #1D2129;
          padding-left: 21px;
          padding: 10px 21px 10px 21px;
        }
      }
    }
    .drag-add {
        text-align: center;
        padding: 10px 0px 10px 0px;
        svg {
          margin-right: 8px;
          width: 16px;
          height: 16px;
          cursor: pointer;
        }
        span {
          color: #2C51EF;
          font-weight: 500;
          font-size: 16px;
          cursor: pointer;
        }
      }
      /deep/.el-input__inner {
          border-color: #DCDFE6 !important;
      }
      /deep/.el-textarea__inner {
        border-color: #DCDFE6 !important;
      }
  }
</style>
